// import { FriendProfile } from "../store/playerFriends";
import type { PlayerConfig, PlayerProfile } from "../types/tokenValley";
import { getHeadersJWT } from "./header";

const GAME_API_HOST = "https://backend.token-valley.hackney.games";
// const TG_GATEWAY_API_HOST = "https://tg-gateway.hackney.games";

export type ServerAnswer = {
  player: PlayerProfile;
  config: PlayerConfig;
  events: { claims: { position: string; amount: number }[] };
  updated_previous?: number;
};

export const newTokenValleyPlayer: PlayerProfile = {
  hackneyId: "",
  firstName: "Hack Ney",
  telegramId: "000",
  player_blocks_available: [],
  updated: 0,
  tutorial_step: -1,
  player_resources: {},
  lab_researched: [],
  valley_map: {},
};

export const getMe = async () => {
  const requestOptions = {
    method: "GET",
    headers: getHeadersJWT(),
  };

  const response = await fetch(`${GAME_API_HOST}/me`, requestOptions);
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  const body = await response.json();

  return body as ServerAnswer;
};

// export const getTop = async () => {
//   const requestOptions = {
//     method: "GET",
//     headers: getHeadersJWT(),
//   };

//   const response = await fetch(`${GAME_API_HOST}/ranking`, requestOptions);
//   const status = response.status;

//   if (status !== 200) {
//     throw new Error();
//   }

//   const responseClone = response.clone();
//   const bodyText = await responseClone.text();

//   if (!bodyText) {
//     throw new Error();
//   }

//   const body = await response.json();

//   return body as TapCityPlayer[];
// };

export const deleteData = async () => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
  };

  const response = await fetch(`${GAME_API_HOST}/delete-me`, requestOptions);
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

export const move = async (props: {
  original_position: number;
  new_position: number;
  updated: number;
}): Promise<ServerAnswer> => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
    body: JSON.stringify(props),
  };

  const response = await fetch(`${GAME_API_HOST}/move`, requestOptions);
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

export const claimResourcesApi = async (props: {
  resource_name: string;
  updated: number;
}): Promise<ServerAnswer> => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
    body: JSON.stringify(props),
  };

  const response = await fetch(
    `${GAME_API_HOST}/resource-claim`,
    requestOptions,
  );
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

export const taskApi = async (props: {
  valley_block_id: number;
  cycles_planned: number;
  updated: number;
}): Promise<ServerAnswer> => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
    body: JSON.stringify(props),
  };

  const response = await fetch(
    `${GAME_API_HOST}/task`,
    requestOptions,
  );
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

export const exchange = async (props: {
  exchange_x_pos: number;
  exchange_y_pos: number;
  resource_type: number;
  resource_amount: number;
  resource_price: number;
  updated: number;
}): Promise<ServerAnswer> => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
    body: JSON.stringify(props),
  };

  const response = await fetch(`${GAME_API_HOST}/exchange`, requestOptions);
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

export const build = async (props: {
  x: number;
  y: number;
  updated: number;
  block_type: string;
}): Promise<ServerAnswer> => {
  const requestOptions = {
    method: "POST",
    headers: getHeadersJWT(),
    body: JSON.stringify(props),
  };

  const response = await fetch(`${GAME_API_HOST}/build`, requestOptions);
  const status = response.status;

  if (status !== 200) {
    throw new Error();
  }

  const responseClone = response.clone();
  const bodyText = await responseClone.text();

  if (!bodyText) {
    throw new Error();
  }

  return await response.json();
};

// export const claimFriend = async (props: any): Promise<TapCityPlayer> => {
//   const requestOptions = {
//     method: "POST",
//     headers: getHeadersJWT(),
//     body: JSON.stringify(props),
//   };

//   const response = await fetch(
//     `${GAME_API_HOST}/friends/claim`,
//     requestOptions,
//   );
//   const status = response.status;

//   if (status !== 200) {
//     throw new Error();
//   }

//   const responseClone = response.clone();
//   const bodyText = await responseClone.text();

//   if (!bodyText) {
//     throw new Error();
//   }

//   return await response.json();
// };
